/* Shared AJAX add-to-cart for all EC3D sections. Delegated, so it covers
   sections rendered later by the theme editor too. Falls back to /cart. */
(function () {
  if (window.__ec3dCartBound) return;
  window.__ec3dCartBound = true;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ec3d-atc]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var id = btn.getAttribute('data-vid');
    if (!id) return;
    var label = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = 'Adding…';

    fetch(window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () {
        btn.innerHTML = 'Added ✓';
        // nudge the theme's cart UI to refresh, then restore the label
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
        if (window.Shopify && window.Shopify.onCartUpdate) { try { window.Shopify.onCartUpdate(); } catch (err) {} }
        setTimeout(function () { btn.innerHTML = label; btn.disabled = false; }, 1600);
      })
      .catch(function () { window.location.href = '/cart'; });
  });
})();
